module.exports = __webpack_public_path__ + "img/logo-horizontal-dark-wt-play-tech.5fee7dc5.png";